import * as React from 'react';
const SvgStack = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.744 10.22c-.124.2-.29.371-.485.503l-5.084 3.432a2.1 2.1 0 0 1-2.35 0L3.74 10.723a1.68 1.68 0 0 1-.655-1.924l5.749 3.831a2.1 2.1 0 0 0 2.196.083l.134-.083 5.749-3.832c.152.46.107.98-.17 1.422m.17 1.31a1.68 1.68 0 0 1-.655 1.924l-5.084 3.432c-.71.48-1.64.48-2.35 0L3.74 13.454a1.68 1.68 0 0 1-.655-1.924l5.749 3.832a2.1 2.1 0 0 0 2.196.082l.134-.083zm-5.749-8.677 5.35 3.566a.84.84 0 0 1 0 1.398l-5.35 3.566a2.1 2.1 0 0 1-2.33 0l-5.35-3.566a.84.84 0 0 1 0-1.398l5.35-3.566a2.1 2.1 0 0 1 2.33 0m-1.534.993-.097.056L4.71 7.118l4.824 3.216a.84.84 0 0 0 .835.056l.097-.056 4.823-3.216-4.823-3.216a.84.84 0 0 0-.835-.056"
    />
  </svg>
);
export default SvgStack;
